import { apiRequest } from "../apiRequest";

export const inviteAdmin = (data) => {
  return apiRequest(`/admin/auth/invite/create`, "POST", data);
};

export const verifyAdmin = (data) => {
  return apiRequest(`/admin/auth/invite/verify`, "POST", data);
};
